import { FILTER_TYPES } from '../types.ts';

export const FILTER_ERROR_MESSAGES: Record<string, string> = {
  [FILTER_TYPES.RADIO]: 'selectedOptions must be a string for radio type',
  [FILTER_TYPES.CHECKBOX]: 'selectedOptions must be a string array for checkbox type',
  [FILTER_TYPES.AUTOCOMPLETE]: 'selectedOptions must be a string array for autocomplete type',
  [FILTER_TYPES.RANGE]: 'selectedOptions must be a tuple of two strings for range type',
  [FILTER_TYPES.MULTI_OPTION_WITH_RANGE]: 'selectedOptions must be a string array for multi-option with range type',
  [FILTER_TYPES.MULTI_OPTION_WITH_RADIO]: 'selectedOptions must be a string array',
  [FILTER_TYPES.NUMERIC_INPUT]: 'selectedOptions must be a string for numeric-input type',
  [FILTER_TYPES.TEXT_INPUT]: 'selectedOptions must be a string for text-input type',
};
